import React from "react";
import { Modal, Space } from "antd";
import { RiHistoryLine } from "react-icons/ri";
import { HistoryWorkspaceCore } from "./core/HistoryWorkspaceCore";

const HistoryWorkspaceModal = ({ open, onClose, machineID }) => {
  if (!open) return null;

  return (
    <Modal
      title={
        <Space>
          <RiHistoryLine />
          <span>歷史資料</span>
        </Space>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width="95%"
      style={{ top: 20, maxWidth: 1600 }}
      bodyStyle={{
        padding: 16,
        maxHeight: "calc(100vh - 120px)",
        overflow: "auto",
      }}
      destroyOnClose
    >
      <HistoryWorkspaceCore machineID={machineID} className="modal-variant" />
    </Modal>
  );
};

export default HistoryWorkspaceModal;
